import { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAuth } from "react-oidc-context";
import Icon from "@ant-design/icons";
import { Menu, Layout } from "antd";

import { ReactComponent as Registration } from "../../icons/registration.svg";

import "./index.css";

const createMenuItem = (key, id, defaultMessage, icon) => ({
  key: key,
  icon: <Icon component={icon} className="sidebar-icon" />,
  label: (
    <Link to={key}>
      <FormattedMessage id={id} defaultMessage={defaultMessage} />
    </Link>
  ),
});

const SideBar = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  const items = useMemo(
    () => [createMenuItem("/form", "registration", "Registrace", Registration)],
    []
  );

  return isAuthenticated && false ? (
    <Layout.Sider theme="light" breakpoint="xxl">
      <Menu
        items={items}
        mode="inline"
        className="sidebar-menu"
        selectedKeys={[pathname]}
      />
    </Layout.Sider>
  ) : (
    <></>
  );
};

export default SideBar;
